import { useEffect } from "react";

const SITE_URL = "https://arunguptaandco.com";
const DEFAULT_IMAGE = `${SITE_URL}/brand/logo.png`;

// Lightweight SEO hook: sets title, meta description, canonical and OG/Twitter tags.
export default function useSEO({ title, description, path = "", image = DEFAULT_IMAGE }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Arun Gupta & Co. Chartered Accountants`
      : "Arun Gupta & Co. — Chartered Accountants in Kanpur";
    document.title = fullTitle;

    const canonical = `${SITE_URL}${path}`;

    const setMeta = (selector, attr, key, content) => {
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
    }
    setMeta('meta[property="og:title"]', "property", "og:title", fullTitle);
    if (description)
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[property="og:url"]', "property", "og:url", canonical);
    setMeta('meta[property="og:image"]', "property", "og:image", image);
    setMeta('meta[property="og:site_name"]', "property", "og:site_name", "Arun Gupta & Co.");
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", fullTitle);
    if (description)
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
  }, [title, description, path, image]);
}
